import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const AttendanceScheduleTable = ({ onClick, person, teacher, blocks }) => {
  const { t } = useTranslation();

  const days = {
    1: 'Pondelok',
    2: 'Utorok',
    3: 'Streda',
    4: 'Štvrtok',
    5: 'Piatok',
  };

  const blocksColors = {
    'Lab. cvičenie': '#bfe9fc',
    Prednáška: '#fae2a8',
    Cvičenie: '#bfe9fc',
  };

  const blockTypes = {
    'Lab. cvičenie': 'L',
    Prednáška: 'P',
    Cvičenie: 'C',
  };

  return (
    <>
      <div className="overview-table">
        <table style={{ display: 'table' }}>
          <thead>
            <tr style={{ textAlign: 'center' }}>
              <th style={{ background: 'transparent' }}></th>
              {(() => {
                const headers = [];

                for (let i = 1; i <= 13; i++) {
                  headers.push(
                    <th style={{ border: '1px solid black' }} key={i}>
                      {i}
                      <br />
                      {i + 6 + ':00'}
                    </th>,
                  );
                }
                return headers;
              })()}
            </tr>
          </thead>
          <tbody>
            {(() => {
              const rows = [];

              for (let i = 1; i <= 5; i++) {
                const day = i;
                const cells = [
                  <td
                    key={day}
                    style={{ border: '1px solid black', position: 'static' }}
                  >
                    {days[day]}
                  </td>,
                ];

                for (let j = 1; j <= 13; j++) {
                  const blockInt = j;
                  let cell = (
                    <td
                      key={day + '' + blockInt}
                      style={{ border: '1px solid black' }}
                    ></td>
                  );

                  for (let b of blocks) {
                    if (b.day + '' + b.block === day + '' + blockInt) {
                      const blockLength = !Number.isInteger(b.blocks)
                        ? b.blocks.split(', ').length
                        : 1;

                      if (
                        b.day === new Date().getDay() &&
                        parseInt(b.start_at.split(':')[0]) <=
                          new Date().getHours() &&
                        parseInt(b.end_at.split(':')[0]) >=
                          new Date().getHours()
                      ) {
                        cell = (
                          <td
                            colSpan={blockLength}
                            key={day + '' + blockInt}
                            style={{
                              maxWidth: '80px',
                              border: '1px solid black',
                              background: blocksColors[b.type],
                              wordBreak: 'break-word',
                              color: 'blue',
                              textDecoration: 'underline',
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              onClick(person, teacher, b);
                            }}
                          >
                            {blockTypes[b.type]}
                            <br />
                            {b.room}
                            <br />
                            {b.code} {b.course}
                          </td>
                        );
                      } else {
                        cell = (
                          <td
                            colSpan={blockLength}
                            key={day + '' + blockInt}
                            style={{
                              maxWidth: '80px',
                              border: '1px solid black',
                              background: blocksColors[b.type],
                              wordBreak: 'break-word',
                            }}
                          >
                            {blockTypes[b.type]}
                            <br />
                            {b.room}
                            <br />
                            {b.code} {b.course}
                          </td>
                        );
                      }
                      j += blockLength - 1; // Skip the next block
                      break;
                    }
                  }

                  cells.push(cell);
                }

                rows.push(
                  <tr
                    key={day}
                    style={{
                      textAlign: 'center',
                      fontWeight: 'bold',
                      height: '100px',
                    }}
                  >
                    {cells}
                  </tr>,
                );
              }

              return rows;
            })()}
          </tbody>
        </table>
      </div>
    </>
  );
};

AttendanceScheduleTable.propTypes = {
  onClick: PropTypes.func,
  person: PropTypes.number,
  teacher: PropTypes.number,
  blocks: PropTypes.array,
};

export default AttendanceScheduleTable;
